import { render, staticRenderFns } from "./UserHoverCard.vue?vue&type=template&id=657f27fa&"
import script from "./UserHoverCard.vue?vue&type=script&lang=js&"
export * from "./UserHoverCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports